'use client';
import React from 'react';
import styled from 'styled-components';

type sectionProps = {
  headingText?: string;
  descriptionText?: string;
  className?: string;
  isSectionDark?: boolean;
  headingStyle?: string;
  descriptionStyle?: string;
};
const HighlitedDescription = styled.h2``;
const SectionHeader = ({
  headingText,
  descriptionText,
  className,
  isSectionDark,
  headingStyle,
  descriptionStyle,
}: sectionProps) => {
  return (
    <>
      <div className={`flex flex-col gap-5 ${className}`}>
        {headingText && (
          <HighlitedDescription
            dangerouslySetInnerHTML={{
              __html: headingText || '',
            }}
            className={`text-center font-opt text-[32px] font-medium leading-10 lg:text-[40px] lg:leading-[44px] ${isSectionDark ? 'text-white' : 'text-primary'} ${headingStyle}`}
          />
        )}
        {descriptionText && (
          <p
            className={`w-full text-center font-opt text-base font-normal leading-5 md:text-xl md:leading-7 ${isSectionDark ? 'text-white/80' : 'text-optDesc'} ${descriptionStyle}`}
          >
            {descriptionText}
          </p>
        )}
      </div>
    </>
  );
};

export default SectionHeader;
